export default __webpack_public_path__ + "images/success.v-1b9d52d343f0428b58df9883b947ecff.svg";